module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_badge_base_ghost-20c827ff0f5c30797a9b52349d56992f.png";